import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { overviewApi, type Period } from "../api/overview";
import StatCard from "../components/cards/StatCard";
import UsageTrendChart from "../components/charts/UsageTrendChart";

export default function Overview() {
  const [period, setPeriod] = useState<Period>("7d");
  const stats = useQuery({ queryKey: ["overview", period], queryFn: () => overviewApi.stats(period) });
  const trend = useQuery({
    queryKey: ["overview-trend", period],
    queryFn: () => overviewApi.trend(period, "day"),
  });

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-slate-900">Overview</h2>
        <div className="flex gap-1 rounded border border-slate-200 bg-white p-0.5 text-sm">
          {(["7d", "30d", "90d"] as Period[]).map((p) => (
            <button
              key={p}
              onClick={() => setPeriod(p)}
              className={`rounded px-3 py-1 ${
                period === p ? "bg-brand-50 text-brand-700 font-medium" : "text-slate-600"
              }`}
            >
              {p}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard label="Desktop Events" value={stats.data?.event_count ?? "—"} />
        <StatCard label="Active Users (Desktop)" value={stats.data?.active_users ?? "—"} />
        <StatCard
          label="Total Cost"
          value={stats.data ? `$${stats.data.total_cost_usd.toFixed(2)}` : "—"}
          hint="Approximate (Anthropic billing is ground truth)"
        />
        <StatCard label="Errors" value={stats.data?.error_count ?? "—"} />
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        <StatCard label="Web Chat Conversations" value={stats.data?.web_chat_conversations ?? "—"} />
        <StatCard label="Web Chat Users" value={stats.data?.web_chat_users ?? "—"} />
        <StatCard label="Web Chat Turns" value={stats.data?.web_chat_turns ?? "—"} />
      </div>

      {trend.data && <UsageTrendChart data={trend.data} />}
    </div>
  );
}
